import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import { appBar, toolbar } from './styles';
import { GrabModalLogo } from '@new-components/shapes';

const Header = () => {
  return (
    <AppBar position='fixed' className={appBar}>
      <Toolbar className={toolbar}>
        <GrabModalLogo />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
